<template>
  <div class="bg-white border-solid border-0 border-l border-gray-a10 h-full flex flex-col px-4 pt-4">
    <span class="font-bold text-gray-dark text-xl">Event</span>

    <div class="text-gray-dark font-semibold mt-4">Event name</div>
    <div class="text-gray-dark">{{ eventName }}</div>

    <div class="text-gray-dark font-semibold mt-4">Event description</div>
    <div class="text-gray-dark">{{ eventDescription }}</div>

    <base-button
      v-if="eventId"
      variant="bordered"
      class="w-full mt-10"
      :router-link="getRouteDetails()"
    >
      Edit event
    </base-button>
  </div>
</template>

<script>
import { ROUTE_NAMES } from '@/router'
import botModule from '@/store/modules/bot.module'

export default {
  name: 'EventDetail',

  props: {
    formData: {
      type: Object,
      default: null
    }
  },

  computed: {
    botId: () => botModule.getBot()?.id,

    event() {
      return this.formData?.data?.event
    },

    eventId() {
      return this.event?.id
    },

    eventName() {
      return this.event?.name
    },
  
    eventDescription() {
      return this.event?.description
    }
  },

  methods: {
    getRouteDetails() {
      return {
        name: ROUTE_NAMES.events,
        params: {
          eventId: this.eventId,
          botId: this.botId
        }
      }
    }
  }
}
</script>
